

exports.__esModule = true;

var _squid = require('squid');

var _angular = require('angular');

var _uiRouter = require('uiRouter');

var _util = require('xo-return-to-merchant/dist/util');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

require('./styles');

var _util2 = require('./util');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var INVALID_ADDRESS_KEY_MAPPING = {
    TITLE: 'errorInfo',
    CONTENT: 'errorDetail'
};

exports['default'] = _squid.$Component.extend('$xoInvalidAddressComponent', {
    tag: 'xo-invalid-address-error',
    template: _template2['default'],

    resolve: {
        models: function models() {}
    },

    lifecycle: {
        enter: function enter() {
            var _this = this;

            _angular.$rootScope.isShoppingCart = true;

            var xclickParams = _squid.$meta.xclickParams;

            this.mappedParameters = (0, _util2.getInvalidAddressRequiredParams)(xclickParams);

            this.requiredDetailsForAddressOverride = this.mappedParameters && this.mappedParameters.requiredDetailsForAddressOverride;

            this.address = this.requiredDetailsForAddressOverride && this.requiredDetailsForAddressOverride.shipping_address;

            this.redirectLink = this.requiredDetailsForAddressOverride && this.requiredDetailsForAddressOverride.urls && this.requiredDetailsForAddressOverride.urls.cancel_return || document.referrer;

            this.buyerInfo = this.requiredDetailsForAddressOverride && this.requiredDetailsForAddressOverride.payer_info;

            var merchantDetails = (0, _util2.getMerchantDetails)(this.requiredDetailsForAddressOverride);
            _angular.$rootScope.$broadcast('merchantDetails', merchantDetails);
            this.merchant = merchantDetails;

            var error = _uiRouter.$state.params.code;

            var errorFields = _uiRouter.$state.params.data;

            if (error && errorFields) {
                this.invalidFields = mapInvalidFields(errorFields.split(','));
            }

            function mapInvalidFields(fields) {
                return {
                    line1: fields.includes('line1'),
                    line2: fields.includes('line2'),
                    state: fields.includes('state'),
                    city: fields.includes('city'),
                    postal_code: fields.includes('zip'),
                    country: fields.includes('country')
                };
            }

            var cancelPreventStateChange = _angular.$rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
                event.preventDefault();
            });

            this.$on('$destroy', cancelPreventStateChange);

            this.highLightInvalidFields = function () {
                _this.invalid = _this.invalidFields;
                if (_this.invalid.line1 || _this.invalid.line2) {
                    angular.element('#secondLineText').css('font-weight', 'bold');
                }
                if (_this.invalid.city || _this.invalid.state || _this.invalid.postal_code) {
                    angular.element('#thirdLineText').css('font-weight', 'bold');
                }
            };

            // Format invalid address info

            this.formatInvalidAddress = function () {

                function postfix(str, postfixStr) {
                    if (str) {
                        return '' + str + (postfixStr || '');
                    }
                    return '';
                }

                var buyerInfo = _this.buyerInfo,
                    firstName = buyerInfo && buyerInfo.first_name || '',
                    lastName = buyerInfo && buyerInfo.last_name || '';

                var address = _this.address;

                var line1 = '',
                    line2 = '',
                    city = '',
                    state = '',
                    postal_code = '';

                if (address) {
                    line1 = address.line1;
                    line2 = address.line2;
                    city = address.city;
                    state = address.state;
                    postal_code = address.postal_code;
                }

                var firstLine = postfix(firstName + ' ' + lastName, '\n');
                var secondLine = postfix(line1 + ' ' + line2, '\n');
                var thirdLine = postfix(city + ' ' + state + '  ' + postal_code);

                _this.highLightInvalidFields();

                return {
                    firstLine: firstLine,
                    secondLine: secondLine,
                    thirdLine: thirdLine
                };
            };

            this.redirect = function ($event) {
                $event.preventDefault();
                var redirectUrl = this.redirectLink;
                _util.$ReturnToMerchant.goTo(redirectUrl);
            };

            $('.paypalHeaderWrapper').hide();
            $('#defaultCancelLink').hide();
            $('.footerWrapper').addClass('genericError');

            var titleKey = INVALID_ADDRESS_KEY_MAPPING.TITLE;

            if (titleKey) {
                this.titleKey = 'shippingAddress.' + titleKey;
            }

            var contentKey = INVALID_ADDRESS_KEY_MAPPING.CONTENT;

            this.contentKey = 'shippingAddress.' + contentKey;

            this.$on('$destroy', function (event) {
                $('.paypalHeaderWrapper').show();
                $('#defaultCancelLink').show();
                $('.footerWrapper').removeClass('genericError');
            });

            // Returns the title string, based on custom key handler
            this.getTitle = function () {
                var key = _this.titleKey;

                return (0, _squid.$renderContent)(key);
            };

            // Returns the content string, based on custom key handler
            this.getContent = function () {

                var key = _this.contentKey;

                return (0, _squid.$renderContent)(key);
            };

            // Returns the redirect to merchant button label, based on presence of brand/merchant name
            this.getRedirectLabel = function () {
                var merchantName = _this.merchant.brand_name;

                if (merchantName) {
                    return (0, _squid.$renderContent)('common.returnToMerchant', { merchantName: merchantName });
                }

                return (0, _squid.$renderContent)('common.returnToDefaultMerchant');
            };
        },
        populate: function populate() {

            this.shippingAddress = this.formatInvalidAddress();
        }
    }
});


_squid.$Component;

_squid.$meta;

_squid.$renderContent;

_angular.$rootScope;

_uiRouter.$state;

_util.$ReturnToMerchant;

_util2.getInvalidAddressRequiredParams;

_util2.getMerchantDetails;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./pages/xo-error/xo-invalid-address-error/directive.js
// module id = ./pages/xo-error/xo-invalid-address-error/directive.js
// module chunks = 1